import { render } from "./UserchangePassword.vue?vue&type=template&id=b2dc0ac4&scoped=true"
import script from "./UserchangePassword.vue?vue&type=script&scoped=true&lang=js"
export * from "./UserchangePassword.vue?vue&type=script&scoped=true&lang=js"

import "./UserchangePassword.vue?vue&type=style&index=0&id=b2dc0ac4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2dc0ac4"]])

export default __exports__